/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 */
import React, { Component } from 'react';
import WhatShot from 'material-ui/svg-icons/social/whatshot';
import Telefono from 'material-ui/svg-icons/communication/phone';
import CorreoElectronico from 'material-ui/svg-icons/communication/email';
import RFC from 'material-ui/svg-icons/communication/vpn-key';
import Calle from 'material-ui/svg-icons/maps/streetview';
import NumeroLocal from 'material-ui/svg-icons/editor/format-list-numbered';
import CodigoPostal from 'material-ui/svg-icons/action/code';
import Colonia from 'material-ui/svg-icons/action/find-replace';
import Ciudad from 'material-ui/svg-icons/social/location-city';
import Pais from 'material-ui/svg-icons/action/account-balance';
import { TextField } from 'material-ui';
import Agregar from 'material-ui/svg-icons/content/add-circle';
import IconButton from 'material-ui/IconButton';
import { EditableInline } from '../text';
import Filter from './filter';
import Container from './container';
import { RemoteDropDownSearch } from '../../components/data-containers';


const filter = {
    name: '',
    taxId: '',
    street: '',
    externalNumber:'',
    internalNumber: '',
    zipCode:'',
    colony:'',
    city: '',
    municipality:'',
    state:'',
    country:''
};


const searchTexts = {
    supplierText: ''
};

class FilterContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...filter, ...searchTexts};
    }

    updateValue = (path, value) => {
        this.setState({ [path]: value });
    };

    render() {
        const { children, onSearch, onClear } = this.props;
        const { supplierText, name, taxId, phone1, email1, street, externalNumber, internalNumber, zipCode, colony, city, municipality, state, country } = this.state;

        return (
            <Container
                contents={children}
                onSearch={() => onSearch(this.state)}
                onClear={() => {
                  this.setState({ ...filter, ...searchTexts })
                  onClear(this.state);
                }}
            >
                <Filter icon={<WhatShot />} title="Razon Social" id="razonsocial">
                <TextField
                    hintText="Razón social..."
                    fullWidth
                    value={name}
                    onChange={(event, value) => this.updateValue('name', value)}
                />
                </Filter>

                <Filter icon={<RFC />} title="RFC" id="rfc">
                    <TextField
                        hintText="RFC..."
                        fullWidth
                        value={taxId}
                        onChange={(event, value) => this.updateValue('taxId', value)}
                    />
                </Filter>
                <Filter icon={<Calle />} title="Calle" id="calle">
                    <TextField
                        hintText="calle"
                        fullWidth
                        value={street}
                        onChange={(event, value) => this.updateValue('street', value)}
                    />
                </Filter>
                <Filter icon={<NumeroLocal />} title="Numero Ext." id="numeroexterior">
                    <TextField
                        type="number"
                        hintText="Numero Ext."
                        fullWidth
                        value={externalNumber}
                        onChange={(event, value) => this.updateValue('externalNumber', value)}
                    />
                </Filter>

                <Filter icon={<NumeroLocal />} title="Numero Interior" id="numerointerior">
                    <TextField
                        type="number"
                        hintText="Numero Int."
                        fullWidth
                        value={internalNumber}
                        onChange={(event, value) => this.updateValue('internalNumber', value)}
                    />
                </Filter>

                <Filter icon={<CodigoPostal />} title="Codigo Postal" id="codigopostal">
                    <TextField

                        hintText="Codigo Postal"
                        fullWidth
                        value={zipCode}
                        onChange={(event, value) => this.updateValue('zipCode', value)}
                    />
                </Filter>

                <Filter icon={<Colonia />} title="Colonia" id="colonia">
                    <TextField
                        hintText="Colonia"
                        fullWidth
                        value={colony}
                        onChange={(event, value) => this.updateValue('colony', value)}
                    />
                </Filter>

                <Filter icon={<Ciudad />} title="Ciudad" id="ciudad">
                    <TextField
                        hintText="Ciudad"
                        fullWidth
                        value={city}
                        onChange={(event, value) => this.updateValue('city', value)}
                    />
                </Filter>

                <Filter icon={<Ciudad />} title="Municipio" id="municipio">
                    <TextField
                        hintText="municipio"
                        fullWidth
                        value={municipality}
                        onChange={(event, value) => this.updateValue('municipality', value)}
                    />
                </Filter>

                <Filter icon={<Ciudad />} title="Estado" id="estado">
                    <TextField
                        hintText="Estado"
                        fullWidth
                        value={state}
                        onChange={(event, value) => this.updateValue('state', value)}
                    />
                </Filter>

                <Filter icon={<Pais />} title="Pais" id="pais">
                    <TextField
                        hintText="Pais"
                        fullWidth
                        value={country}
                        onChange={(event, value) => this.updateValue('country', value)}
                    />
                </Filter>
            </Container>
        );
    }
}

export default FilterContainer;



// WEBPACK FOOTER //
// ./components/filters/proveedores.js